export function compareNumbers(a: any, b: any) {
  return a - b;
}
